import { Anchor, Container, Group, Stack, Text } from '@mantine/core';
import { Link } from 'react-router-dom';
import { LockIcon } from '@phosphor-icons/react';
import { useStrings } from '@/i18n/useLang';

export function Footer() {
  const t = useStrings();

  return (
    <footer
      style={{
        borderTop: '1px solid var(--border)',
        marginTop: '4rem',
        background: 'var(--bg-card)',
      }}
    >
      <Container size="lg" py="xl">
        <Stack gap="sm">
          <Group gap="xs">
            <LockIcon size={16} color="var(--success)" />
            <Text size="sm" c="dimmed">
              {t.footer.noStorage}
            </Text>
          </Group>
          <Group justify="space-between" wrap="wrap">
            <Text size="sm" c="dimmed">
              {t.footer.rights}
            </Text>
            <Group gap="md">
              <Anchor href="/sshgen/" size="sm" c="dimmed">
                {t.nav.sshKeys}
              </Anchor>
              <Anchor component={Link} to="/datenschutz" size="sm" c="dimmed">
                {t.nav.privacy}
              </Anchor>
              <Anchor component={Link} to="/impressum" size="sm" c="dimmed">
                {t.nav.imprint}
              </Anchor>
            </Group>
          </Group>
        </Stack>
      </Container>
    </footer>
  );
}
